import { ApiError } from '@/api/http/types'
import { SP_PASSWORD_SAVE_FAILED_MESSAGE } from './password-messages'

/** Network/API password save failures — toast, not inline (BFP-264). */
export function isPasswordSaveDeliveryFailure(error: unknown): boolean {
  if (!(error instanceof ApiError)) {
    return true
  }
  if (error.isValidation) {
    return false
  }
  if (
    error.fieldError('new_password') != null ||
    error.fieldError('confirm_password') != null
  ) {
    return false
  }
  if (error.status === 400 || error.status === 422) {
    return false
  }
  return true
}

export function resolvePasswordSaveFailureMessage(error: unknown): string {
  if (
    error instanceof ApiError &&
    error.message === SP_PASSWORD_SAVE_FAILED_MESSAGE
  ) {
    return error.message
  }
  return SP_PASSWORD_SAVE_FAILED_MESSAGE
}

export function resolveInlinePasswordSaveError(error: unknown): string {
  if (!(error instanceof ApiError)) {
    return 'An unexpected error occurred. Please try again.'
  }
  const confirmIssue = error.fieldError('confirm_password')
  const pwIssue = error.fieldError('new_password')
  return confirmIssue ?? pwIssue ?? error.message
}
